/* The D3 poster mockup's `.hair` / `.hair i`. Every value is a KANON token reference — Stylelint
 * fails the build on a literal. */

.rail {
  position: absolute;

  /* Across the very top of the whole page, both panes included: the bar belongs to the visit, not
   * to the form column. `.shell` is the positioned ancestor. */
  inset: var(--space-0) var(--space-0) auto;
  z-index: 1;
  height: var(--space-2px);
  background: var(--border);
}

/* Full width, scaled from the left — see the component header for why a transform and not a width. */
.fill {
  display: block;
  width: 100%;
  height: 100%;
  transform-origin: left center;
  background: var(--accent);
}
